import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { string } from 'prop-types';
import styles from './style.module.css';

const Modal = dynamic(() => import('antd/lib/modal/Modal'));

function GuarantyInfoGiftGuide({ stripedHtml }) {
  const [ isModalVisible, setIsModalVisible ] = useState(false);
  const openModalGiftGuide = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <>
      <li className={`${styles.guarantyText} ${styles.guarantyGiftGuideText}`} onClick={openModalGiftGuide}>
        {stripedHtml}
      </li>
      <Modal
        title="Bolsa de regalo"
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancel}
        width={'80%'}
      >
        <p>
          {stripedHtml}
        </p>
      </Modal>
    </>
  );
}

GuarantyInfoGiftGuide.propTypes = {
  stripedHtml: string,
};

function GuarantyInfo({ infoText }) {
  return (
    <li className={styles.guarantyText} dangerouslySetInnerHTML={{ __html: infoText }} />
  );
}

GuarantyInfo.propTypes = {
  infoText: string,
};

export default GuarantyInfo;
